export default "__VITE_ASSET__85601a74__"